import { Radio, type RadioChangeEvent } from "antd";
import { type FunctionComponent } from "react";

import { BTIconList, BTIconTile } from "commonComponents/btWrappers/BTIcon";
import { BTRadioGroupDeprecated } from "commonComponents/btWrappers/BTRadioGroupDeprecated/BTRadioGroupDeprecated";

import { type SelectedMediaListViews } from "entity/media/common/mediaTypes";

import "./FileViewToggle.less";

interface IFileViewToggleProps {
    value: SelectedMediaListViews;
    onChange: (value: SelectedMediaListViews) => void;
    className?: string;
}

export const FileViewToggle: FunctionComponent<IFileViewToggleProps> = ({ value, onChange }) => {
    const handleChange = (e: RadioChangeEvent) => {
        // Stop event propagation to prevent clicks from bubbling up to parent components
        e.stopPropagation();
        onChange(e.target.value);
    };

    const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        // Stop event propagation to prevent clicks from bubbling up to parent components
        e.stopPropagation();
    };

    return (
        <BTRadioGroupDeprecated
            id="fileViewToggle"
            data-testid="fileViewToggle"
            onChange={handleChange}
            className="media-list-file-toggle"
            value={value}
        >
            <Radio.Button value="Tile" onClick={handleButtonClick} data-testid="fileViewTile">
                <BTIconTile size={20} className="media-list-file-toggle-icon" />
            </Radio.Button>
            <Radio.Button value="Table" onClick={handleButtonClick} data-testid="fileViewTable">
                <BTIconList size={20} className="media-list-file-toggle-icon" />
            </Radio.Button>
        </BTRadioGroupDeprecated>
    );
};
